<h3 mat-dialog-content>Dodaj uczestnika do bazy</h3>
<mat-dialog-content class="pt-4">
	<ng-container>
		<div class="d-flex flex-row flex-wrap gap-2" [formGroup]="participantForm">
			<mat-form-field appearance="outline">
				<mat-label>Zwrot grzecznościowy</mat-label>
				<mat-select placeholder="Pan" formControlName="sex">
					<mat-option value="M">Pan</mat-option>
					<mat-option value="F">Pani</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Imię</mat-label>
				<input type="text" matInput required formControlName="firstName" />
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Nazwisko</mat-label>
				<input type="text" matInput required formControlName="lastName" />
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Data urodzenia</mat-label>
				<input matInput [matDatepicker]="datepicker" formControlName="birth" />
				<mat-hint>MM/DD/YYYY</mat-hint>
				<mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
				<mat-datepicker #datepicker>
					<mat-datepicker-actions>
						<button mat-button matDatepickerCancel>Anuluj</button>
						<button mat-raised-button color="primary" matDatepickerApply>Zatwierdź</button>
					</mat-datepicker-actions>
				</mat-datepicker>
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Numer telefonu</mat-label>
				<input matInput type="text" placeholder="Numer telefonu" formControlName="phone" />
			</mat-form-field>
		</div>
	</ng-container>

	<div>
		<mat-checkbox [(ngModel)]="regularCustomer"> Stały klient </mat-checkbox>
	</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button (click)="closeDialog()">Porzuć</button>
	<button mat-raised-button color="primary" (click)="submit()" class="submitChanges">Zapisz zmiany</button>
</mat-dialog-actions>
